/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faStarHalfAlt} from '@fortawesome/pro-duotone-svg-icons';

const RubricsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faStarHalfAlt} {...props} />
);

export default RubricsIcon;
